import { useState } from "react";
import { Button, NumberInput, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconShield } from "@tabler/icons-react";

export default function PcBlockModal({ context, id, innerProps }) {
  const [loading, setLoading] = useState(false);
  const onBlock = innerProps.onBlock;

  const form = useForm({
    initialValues: {
      minutes: "",
    },
    validate: {
      minutes: (value) => (value !== "" && value <= 0 ? "Zadej kladný počet minut." : null),
    },
  });

  async function handleSubmit(values) {
    setLoading(true);
    try {
      const durationSeconds = values.minutes === "" ? null : Math.round(values.minutes * 60);
      await onBlock(durationSeconds);
      context.closeModal(id);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <NumberInput
        label="Doba blokace (minuty)"
        placeholder="Nech prázdné pro trvalou blokaci"
        min={1}
        allowDecimal={false}
        data-autofocus
        {...form.getInputProps("minutes")}
      />
      <Text size="sm" c="dimmed" mt="xs">
        Pokud čas nevyplníš, počítač zůstane zablokovaný trvale.
      </Text>

      <Button fullWidth type="submit" loading={loading} mt="md" leftSection={<IconShield size={18} stroke={1.5} />}>
        Zablokovat
      </Button>
    </form>
  );
}
